var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "max-w-3xl mx-auto my-15" },
      [
        _c("DateRangePicker", {
          attrs: { opens: "right", ranges: _vm.ranges },
          on: { update: _vm.dateSelected },
          model: {
            value: _vm.currentConfig,
            callback: function($$v) {
              _vm.currentConfig = $$v
            },
            expression: "currentConfig"
          }
        }),
        _vm.isLoading ? _c("div", [_c("Spinner")], 1) : _vm._e(),
        _c(
          "h3",
          { staticClass: "text-lg leading-6 font-medium text-gray-900 mt-4" },
          [_vm._v(" " + _vm._s(_vm.dateDiff) + " ")]
        ),
        _c(
          "h3",
          { staticClass: "text-lg leading-6 font-medium text-gray-900 mt-5" },
          [_vm._v(" Abandoned carts ")]
        ),
        _c(
          "div",
          { staticClass: "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3" },
          [
            _c(
              "div",
              { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
              [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c("dl", [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500 "
                      },
                      [_vm._v(" Messages sent ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.checkoutReport.totalMessagesSent) +
                            " "
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
              [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c("dl", [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500 "
                      },
                      [_vm._v(" Carts recovered ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.checkoutReport.cartsRecovered) + " "
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
              [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c("dl", [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500 "
                      },
                      [_vm._v(" Cart value recovered ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.checkoutReport.cartsRecoveredValue) +
                            " "
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _c(
          "h3",
          { staticClass: "text-lg leading-6 font-medium text-gray-900 mt-5" },
          [_vm._v(" Chat & share ")]
        ),
        _c(
          "div",
          { staticClass: "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3" },
          [
            _c(
              "div",
              { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
              [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c("dl", [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500 "
                      },
                      [_vm._v(" Chat clicked ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      },
                      [_vm._v(" " + _vm._s(_vm.chatReport.chatClicks) + " ")]
                    )
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
              [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c("dl", [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500 "
                      },
                      [_vm._v(" Share Clicked ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      },
                      [_vm._v(" " + _vm._s(_vm.chatReport.shareClicks) + " ")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _c(
          "h3",
          { staticClass: "text-lg leading-6 font-medium text-gray-900 mt-5" },
          [_vm._v(" Automation ")]
        ),
        _c(
          "div",
          { staticClass: "mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3" },
          [
            _c(
              "div",
              { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
              [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c("dl", [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500 "
                      },
                      [_vm._v(" Abandoned messages sent ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.checkoutReport.automatedMessages) +
                            " "
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
              [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c("dl", [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500 "
                      },
                      [_vm._v(" Order confirmation messages sent ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.automationReport.orderConfirmationMessagesSent
                            ) +
                            " "
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
              [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c("dl", [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500 "
                      },
                      [_vm._v(" Order shipping updates sent ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.automationReport.orderShippingUpdatesSent
                            ) +
                            " "
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
              [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c("dl", [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500 "
                      },
                      [_vm._v(" COD messages sent ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.automationReport.codConfirmationMessagesSent
                            ) +
                            " "
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
              [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c("dl", [
                    _c(
                      "dt",
                      {
                        staticClass:
                          "text-sm leading-5 font-medium text-gray-500 "
                      },
                      [_vm._v(" Review requests sent ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass:
                          "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.automationReport.reviewRequestsSent) +
                            " "
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _vm.config.storeId === "61a59576119cfa2c9e4772b3"
              ? _c(
                  "div",
                  { staticClass: "bg-white overflow-hidden shadow rounded-lg" },
                  [
                    _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                      _c("dl", [
                        _c(
                          "dt",
                          {
                            staticClass:
                              "text-sm leading-5 font-medium text-gray-500 "
                          },
                          [_vm._v(" Short links clicked ")]
                        ),
                        _c(
                          "dd",
                          {
                            staticClass:
                              "mt-1 text-3xl leading-9 font-semibold text-gray-900"
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.urlReport.clickedCount) + " "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm.config.hasClickedWriteAReview === false
          ? _c("ReviewUs", { staticClass: "mt-10" })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }